import React from 'react';
import Router from 'next/router';
import { gql } from '@soundxyz/gql-string';
import { FeedActivityItem } from '@components/Feed/Activities/FeedActivityItem';
import { CommentButtonAction, PostActionButtons } from '@components/Feed/Post/ActionButtons';
import { FeedPostActionsInfoFragmentDoc, type FragmentType } from '@graphql/reactQuery';
import { ArtistDropReleaseFragmentDoc, getFragment } from '@graphql/reactQuery';
import { trackClickEvent } from '@lib/analytics';
import { webappUriPath } from '@utils/url';
import { FeedReleaseCard } from './FeedReleaseCard';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ArtistDropRelease on Release {
    id
    artist {
      id
      user {
        id
        ...FeedActivityItemUserInfo
      }
    }
    ...FeedReleaseCard
  }
`);

export const ArtistDrop = ({
  releaseFrag,
  postActionsFrag,
  timeStamp,
}: {
  releaseFrag: FragmentType<ArtistDropReleaseFragmentDoc>;
  postActionsFrag?: FragmentType<FeedPostActionsInfoFragmentDoc> | null;
  timeStamp: number;
}) => {
  const release = getFragment(ArtistDropReleaseFragmentDoc, releaseFrag);
  const { artist } = release;

  const post = getFragment(FeedPostActionsInfoFragmentDoc, postActionsFrag);

  const content = (
    <FeedActivityItem
      dropdownContent={null}
      userFrag={artist.user}
      description="Dropped a song"
      timestamp={timeStamp}
    >
      <FeedReleaseCard releaseFrag={release} />

      {postActionsFrag && (
        <div className="my-3">
          <PostActionButtons
            commentButtonAction={CommentButtonAction.ShowModal}
            postFrag={postActionsFrag}
            sourceLocation="Artist Drop Card"
            resourceOwnerTwitterHandle={null}
            iconSize={18}
            hideShareButton={false}
            hideRepostButton={false}
            source="Post Feed Card"
            repostSource={null}
          />
        </div>
      )}
    </FeedActivityItem>
  );

  return !!post ? (
    <div
      className="-m-3 cursor-pointer rounded-lg p-3 hover:bg-neutral50 hover:[&_.read-more-button]:bg-neutral200 [&_.read-more-overlay]:hover:from-neutral50"
      data-feed-clickable-div
      onClick={e => {
        if (e.target instanceof HTMLElement) {
          if (e.target.hasAttribute('data-feed-clickable-div')) {
            Router.push(webappUriPath(post.webappUri));

            trackClickEvent({
              event: 'Post Link Clicked',
              properties: {
                associationId: post.id,
                associationType: 'Post',
                sourceComponent: 'Artist Activity Feed',
              },
            });
          }
        }
      }}
    >
      {content}
    </div>
  ) : (
    content
  );
};
